import { TextField } from "@mui/material"
import React from "react"

interface ITextFilterProps {
  id: string
  label: string
  value: string
  sx?: any
  onChange(newValue: string): any
}

export const TextFilter = React.memo(({ id, label, value, onChange, sx }: ITextFilterProps): JSX.Element => {
  const [val, setVal] = React.useState(value)
  const timeout = React.useRef<any>(undefined)
  return (
    <TextField
      id={id}
      value={val}
      label={label}
      onChange={event => {
        const newValue = event.target.value || ""
        clearTimeout(timeout.current)
        setVal(newValue)
        timeout.current = setTimeout(() => onChange(newValue), 500)
      }}
      sx={{ minWidth: "14rem" }}
      size="small"
    />
  )
})
